import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxPageVisibilityService } from '@ultimate/ngx-pagevisibility';
import { Subscription } from 'dexie';
import { StudyFile } from '../../../../models/Study/study-file.model';
import { SaleHorseStudyBase } from '../../../../models/Study/study.model';
import { ViewerService } from '../../../../services/viewer.service';
import { StudyMimeType } from '../../../../shared-new/enums/study-mime-type.enum';
import { StudyStatus } from '../../../../shared-new/enums/study-status.enum';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'study-preview-modal',
  templateUrl: './study-preview-modal.component.html',
  styleUrls: ['./study-preview-modal.component.scss'],
  animations: [
    trigger('slideDown', [
      state('void', style({ height: '0', opacity: 0, overflow: 'hidden' })),
      state('*', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      transition('void <=> *', [
        animate('300ms ease-in-out')
      ])
    ])
  ]
})
export class StudyPreviewModalComponent implements OnInit {
  constructor(
    public modal: NgbActiveModal,
    public sanitizer: DomSanitizer,
    private domSanitizer: DomSanitizer,
    private pageVisiblility: NgxPageVisibilityService,
    private modalService: NgbModal,
    private viewerService: ViewerService
  ) {}

  public url: string;
  public viewerGuid: string;
  public horseName: string;
  public disclosedClientName: string;
  public study: SaleHorseStudyBase;
  public studyFileIds: number[] = []
  public studyFiles: any[] = [];
  private idleTimeout: any;
  private idleTimeInSeconds = 110; // Set the idle time in seconds (2 minutes)
  private countdownSeconds = 10; // Countdown seconds for the swal alert

  visibilityChangesSubscription: Subscription;
  public sanitizedUrl: SafeResourceUrl = null;

  private VIEWER_ORIGIN: string = environment.dicomViewer;
  private messageListener = this.handleMessage.bind(this);

  ngOnInit() {
   // this.disclosedClientName = "";
    if (this.study?.saleHorse) {
      const videos = this.study.studyFiles.filter(x => x.studyFileMimeTypeId == StudyMimeType.SCOPE_VIDEO && x.studyStatusId == StudyStatus.Approved);
      const reports = this.study.studyFiles.filter(x => x.studyFileMimeTypeId == StudyMimeType.XRAY_REPORT && x.studyStatusId == StudyStatus.Approved);
      this.studyFiles = [...videos, ...reports];
      this.studyFiles = this.studyFiles.map((file) => {
        const studyFile = JSON.parse(JSON.stringify(file));
        const mimeType = studyFile.studyFileMimeTypeId;
        studyFile.renderTextBox = false;
        if (mimeType === StudyMimeType.SCOPE_VIDEO) {
          if (this.study.sale.isEnfoceScopes) {
            studyFile.isEnforceClientName = true;
            studyFile.disclosedClientName = this.disclosedClientName;
          } else {
            studyFile.isEnforceClientName = false;
          }
        }

        if (mimeType === StudyMimeType.XRAY_REPORT) {
          if (this.study.sale.isEnfocePDFReports) {
            studyFile.isEnforceClientName = true;
            studyFile.disclosedClientName = this.disclosedClientName;
          } else {
            studyFile.isEnforceClientName = false;
          }
        }

        
        return studyFile;
      })
    }
    
    this.sanitizedUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
      this.url
    );
    window.addEventListener("message", this.messageListener);
  }

  updateDiscloseClientNameAndRenderTextBox(studyFile: any) {
    this.studyFiles = this.studyFiles.map((file) => {
      if (file.studyFileId !== studyFile.studyFileId) {
        file.renderTextBox = false;
        file.disclosedClientName = studyFile.disclosedClientName;
      }
      return file;
    });
  }
  openViewer(e:any,studyFile: any): void {
    if (studyFile.isEnforceClientName && !studyFile.disclosedClientName) {
      studyFile.renderTextBox = !studyFile.renderTextBox;
      this.updateDiscloseClientNameAndRenderTextBox(studyFile);
      e.stopPropagation();
    } else {
      studyFile.renderTextBox = false;
      this.updateDiscloseClientNameAndRenderTextBox(studyFile);
      const mimeType = studyFile.studyFileMimeTypeId;
      if (mimeType === StudyMimeType.SCOPE_VIDEO) {
        this.viewerService.endActivity();
        this.viewerService.playVideo(this.study, studyFile, studyFile.isEnforceClientName ? studyFile.disclosedClientName : "", false, () => {
          this.viewerService.startActivityDicomViewer(this.study, null, this.disclosedClientName, this.studyFileIds);
        });
      }
      if (mimeType === StudyMimeType.XRAY_REPORT) {
        this.viewerService.endActivity();
        this.viewerService.openPdf(this.study, studyFile, studyFile.isEnforceClientName ? studyFile.disclosedClientName : "", false, () => {
          this.viewerService.startActivityDicomViewer(this.study, null, this.disclosedClientName, this.studyFileIds);
        });
      }
    }
  }
  

  ngOnDestroy(): void {
    window.removeEventListener("message", this.messageListener);
  }

  private handleMessage(event: MessageEvent): void {
    if (`${event.origin}/viewer` !== this.VIEWER_ORIGIN) {
      console.warn("Blocked message from unexpected origin:", event.origin);
      return;
    }

    if (event.data === "close-viewer") {
      this.closePopup();
    }
  }

  closePopup(): void {
    // When the viewer iframe has taken the screen, this document's
    // fullscreenElement is the iframe itself. Closing the modal removes it and
    // we would be relying on the browser to implicitly drop out of fullscreen,
    // which leaves the user stranded. Exit explicitly first.
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => {});
    }

    this.modal.close();
  }
}
